module.exports = __webpack_public_path__ + "static/media/icone_ig_branco.77001ba5.png";